import { AdsDetailApi } from '../../api'
import { setRegistrationFormulas } from '../setRegistrationFormulas'

export const fetchRegistrationFormulas = () => async dispatch => {
  const api = new AdsDetailApi()
  const formulas = await api.getRegistrationFormulas()
  dispatch(setRegistrationFormulas(formulas))
}
